import { createFileRoute, redirect } from '@tanstack/react-router';

import { eEstimationDetailTab } from '@/pages/estimation/detail/model';
import type { AvailableRoutes } from '@/types';

export const Route = createFileRoute('/estimation/detail/$estimationId/')({
  beforeLoad: () => {
    throw redirect({
      to: `/estimation/detail/$estimationId/${eEstimationDetailTab.project}` as AvailableRoutes,
    });
  },
});
